import { useEffect, useRef, useState } from "react";
import { BiArchive } from "react-icons/bi";
import { CgShutterstock } from "react-icons/cg";
import { FaUserCircle, FaUsers } from "react-icons/fa";
import { FaChartPie, FaFileInvoice, FaRegAddressCard } from "react-icons/fa6";
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi/";
import { GoDotFill } from "react-icons/go";
import { IoMdClose, IoMdPaper } from "react-icons/io";
import { IoSettingsOutline } from "react-icons/io5";
import {
  MdFactCheck,
  MdLogout,
  MdMapsHomeWork,
  MdOutlineSell,
} from "react-icons/md";
import {
  Menu,
  MenuItem,
  Sidebar,
  SubMenu,
  useProSidebar,
} from "react-pro-sidebar";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";

import axios from "axios";
import { Text } from "components";
import { TbReportMoney } from "react-icons/tb";

const Sidebar1 = (props) => {
  const [showProfile, setshowProfile] = useState(false);
  const { collapseSidebar, collapsed } = useProSidebar();
  let navigate = useNavigate();
  const location = useLocation();

  const [erplist, setErplist] = useState([]);
  const token = sessionStorage.getItem("token");
  const userId = sessionStorage.getItem("userId");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    getAllComapnyUsers();
  }, []);

  const obj = {
    id: userId,
    // company_id: companyId,
  };
  const [companyusers, setCompanyusers] = useState({});

  const getAllComapnyUsers = () => {
    axios
      .post("/api/purple-fusion/companyuser/get", obj, headers)
      .then((response) => {
        setCompanyusers(response.data[0]);
        sessionStorage.setItem("companyName", response.data[0].company_name);
        // console.log("siderbar", response.data[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const profileRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        // Click is outside of profile dropdown, close it
        setshowProfile(false);
      }
    };

    // Add event listener when component mounts
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up event listener when component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [profileRef]);

  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    // console.log(storedErplist);

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  // console.log(erplist);

  const sideBarMenu = [
    // erplist.some(item => item.erp_module_id === 2 && item.view) &&
    {
      // icon: <FaUser className="h-5 mb-3 mt-3  w-full text-gray-800 text-sm" />,
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Users",
      to: "/companyuserlist",
    },
    erplist.some((item) => item.erp_module_id === 3 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Customers",
      to: "/customerList",
    },
    erplist.some((item) => item.erp_module_id === 5 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Subcontractors",
      to: "/subcontractorList",
    },
    erplist.some((item) => item.erp_module_id === 7 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Suppliers",
      to: "/supplierList",
    },
    erplist.some((item) => item.erp_module_id === 49 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Transporters",
      to: "/transporterlist",
    },
  ].filter(Boolean);

  //Item Menu
  const itemMenu = [
    erplist.some((item) => item.erp_module_id === 9 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9 text-red",
      label: "Items",
      to: "/item",
    },
    erplist.some((item) => item.erp_module_id === 40 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Item Customers",
      to: "/itemcustomerlist",
    },
    erplist.some((item) => item.erp_module_id === 38 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Item Suppliers",
      to: "/itemsupplierlist",
    },
    erplist.some((item) => item.erp_module_id === 39 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Item Tax",
      to: "/itemtaxList",
    },
    erplist.some((item) => item.erp_module_id === 41 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Item Quality",
      to: "/qualityinspectiontemplate/list",
    },
  ].filter(Boolean);

  //Work Station
  const ManufactirungMenu = [
    erplist.some((item) => item.erp_module_id === 42 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9 ",
      label: "WorkStation Type",
      to: "/workstationtypelist",
    },
    erplist.some((item) => item.erp_module_id === 10 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "WorkStation",
      to: "/workstationlist",
    },
    erplist.some((item) => item.erp_module_id === 11 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Operation",
      to: "/operationlist",
    },
    erplist.some((item) => item.erp_module_id === 12 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Routing",
      to: "/routing/list",
    },
    erplist.some((item) => item.erp_module_id === 13 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Bill of Material",
      to: "/bom/list",
    },
    erplist.some((item) => item.erp_module_id === 32 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Work Order",
      to: "/workOrder/list",
    },
    erplist.some((item) => item.erp_module_id === 17 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Job Card",
      to: "/WorkOrderListjobcard/list",
      // to: "/jobcard/all",
    },
    // erplist.some((item) => item.erp_module_id === 17 && item.view) && {
    //   className: "h-5 mb-1 mt-1 w-full pl-9",
    //   label: "Job Card Add",
    //   to: "/jobcard/add/new",
    //   // to: "/jobcard/all",
    // },
    erplist.some((item) => item.erp_module_id === 17 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Job Card Rejected Quality check",
      to: "/JobCardProductionRejectionDetailList",
      // to: "/jobcard/all",
    },
  ].filter(Boolean);

  //purchase order
  const Selling = [
    erplist.some((item) => item.erp_module_id === 15 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Customer Purchase Order",
      to: "/purchaseorder/list",
    },

    erplist.some((item) => item.erp_module_id === 23 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Sales  Order",
      to: "/salesorder/list",
    },
    erplist.some((item) => item.erp_module_id === 29 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Tax Invoice",
      to: "/taxinvoice/list",
    },
    erplist.some((item) => item.erp_module_id === 52 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Tax Invoice Cancellation",
      to: "/taxinvoice/cancel/list",
    },

    erplist.some((item) => item.erp_module_id === 45 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "PDI Request",
      to: "/pdirequest/list",
    },
    erplist.some((item) => item.erp_module_id === 59 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Credit Note",
      to: "/CreditDebitNoteAll",
    },
    erplist.some((item) => item.erp_module_id === 60 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Debit Note",
      to: "/DebitNoteAll",
    },
  ].filter(Boolean);

  const Buying = [
    erplist.some((item) => item.erp_module_id === 28 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Supplier Purchase Order",
      to: "/companypurchesorder/list",
    },
    erplist.some((item) => item.erp_module_id === 58 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Gate-Pass Entry",
      to: "/gatepassentry/all",
    },
    erplist.some((item) => item.erp_module_id === 46 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "GRN Entry",
      to: "/companypurchesorderentry/all",
    },
  ].filter(Boolean);

  const DelivaryChallan = [
    erplist.some((item) => item.erp_module_id === 51 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Delivery Challan",
      to: "/delivarychallan/list",
    },
    // erplist.some((item) => item.erp_module_id === 47 && item.view) && {
    //   className: "h-5 mb-1 mt-1 w-full pl-9",
    //   label: "Current Stock",
    //   to: "/currentStock",
    // },
  ].filter(Boolean);

  const StockTransactions = [
    erplist.some((item) => item.erp_module_id === 27 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Stock Transaction",
      to: "/stocktransaction/purchaselist",
    },
    erplist.some((item) => item.erp_module_id === 47 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Current Stock",
      to: "/currentStock",
    },
  ].filter(Boolean);

  const Production = [
    erplist.some((item) => item.erp_module_id === 34 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Capacity Plan",
      to: "/CapacityPlan/list",
    },
  ].filter(Boolean);
  const Quality = [
    erplist.some((item) => item.erp_module_id === 46 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Inward Quality Control",
      to: "/inwardqualitycontrol/list",
    },
  ].filter(Boolean);

  const CompanySetting = [
    // erplist.some((item) => item.erp_module_id === 1 && item.view) && {
    //   className: "h-5 mb-1 mt-1 w-full pl-9",
    //   label: "Company Information",
    //   to: "companysettingsall",
    // },
    erplist.some((item) => item.erp_module_id === 14 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Setting",
      to: "/companysettingsall",
    },
    erplist.some((item) => item.erp_module_id === 31 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "WareHouse Setting",
      to: "/warehouse/list",
    },
    erplist.some((item) => item.erp_module_id === 48 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Company Shift",
      to: "/companyshift/list",
    },
    erplist.some((item) => item.erp_module_id === 54 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "DownTime & RejectedReasons",
      to: "/downtimerejectionreasonsall",
    },
    erplist.some((item) => item.erp_module_id === 61 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Eway-bill Login",
      to: "/ewaybill/login",
    },
  ].filter(Boolean);
  const CompanyAccount = [
    erplist.some((item) => item.erp_module_id === 53 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Code Selection",
      to: "/codeselection",
    },
    erplist.some((item) => item.erp_module_id === 53 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Account Group Creation",
      to: "/chartofaccount",
    },
    // },
    erplist.some((item) => item.erp_module_id === 53 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "GL Account Creation",
      to: "/glcreation",
    },

    erplist.some((item) => item.erp_module_id === 53 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Financial Department",
      to: "/findepartment",
    },
    erplist.some((item) => item.erp_module_id === 53 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Profit Center",
      to: "/profitcenter",
    },
    erplist.some((item) => item.erp_module_id === 53 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Cost Center",
      to: "/costcenter",
    },
    erplist.some((item) => item.erp_module_id === 57 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Purchase Invocie Booking",
      to: "/purchase-invoice-booking",
    },
  ].filter(Boolean);

  const ERPAdministration = [
    erplist.some((item) => item.erp_module_id === 16 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "HSN/SAC Management",
      to: "/HsnSac/all",
    },

    erplist.some((item) => item.erp_module_id === 16 && item.view) && {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Test Dummy Data",
      to: "/testdummydata/getAll",
    },
  ].filter(Boolean);

  const Dashboard = [
    {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Inventory Reports",
      to: "/iteminventoryreorts/all",
    },
    {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Supplier PO Report",
      to: "/supplierpo/all",
    },
    {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Sales Order Report",
      to: "/salesorderreport/all",
    },
    {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Manufacturing Report",
      to: "/jobcardreport/all",
    },
    // {
    //   className: "h-5 mb-1 mt-1 w-full pl-9",
    //   label: "DashBoard",
    //   to: "/dashboardtest",
    // },
    {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Sales Reports",
      to: "/dashboardtestall",
    },

    {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Purchase Reports",
      to: "/dashboardsupplierReportAll",
    },
    // {
    //   className: "h-5 mb-1 mt-1 w-full pl-9",
    //   label: "Job Work",
    //   to: "/report/jobwork",
    // },
 
  ].filter(Boolean);
  const FinancialDashboard = [
    {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Costing",
      to: "/report/product/costing",
    },
      {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Stock Ledger",
      to: "/stockledger",
    },
  ].filter(Boolean);

  const Profile = [
    {
      className: "h-5 mb-1 mt-1 w-full pl-9",
      label: "Item Inventory Report",
      to: "/iteminventoryreorts/all",
    },
  ].filter(Boolean);

  return (
    <>
      {token != null ? (
        <div className="flex flex-col overflow-hidden h-screen  w-full">
          <div className="flex flex-row overflow-hidden h-screen w-full">
            <Sidebar transitionDuration={900}>
              <Menu
                transitionDuration={900}
                menuItemStyles={{
                  button: {
                    padding: 0,
                    gap: "8px",
                    color: "#5b5b5b",
                    fontWeight: 600,
                    fontSize: "14px",
                    fontFamily: "Inter",
                    maxHeight: "36px",
                  },
                }}
                className="flex flex-col items-center justify-start ml-3 m-0 py-0 md:pr-10 pr-3  w-[39%]  "
              >
                {/* <MenuItem
                  rootStyles={{
                    justifyContent: "center",
                    alignItems: "center",
                    height: "40px",
                    paddingTop: "4px",
                  }}
                  className="border-b shadow-md"
                >
                  <div
                    className={
                      collapsed ? "flex items-center m-5" : "flex items-center"
                    }
                  >
                    <MdMenu
                      onClick={() => collapseSidebar(!collapsed)}
                      className="h-[31px] w-[31px]"
                      // src="images/img_materialsymbolsmenu.svg"
                      alt="materialsymbols"
                    />
                  </div>
                  <div className="flex flex-row items-center justify-start w-full pl-2">
                    <Text
                      className="text-2xl md:text-[22px] ml-3 text-purple-500 sm:text-xl tracking-[0.20px] w-[85px]"
                      size="txtInterSemiBold24"
                      style={{ textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)" }}
                    >
                      PurpleFusion
                    </Text>
                  </div>
                </MenuItem> */}
                <Menu
                  rootStyles={{
                    alignItems: "center",
                    height: "40px",
                    paddingTop: "4px",
                    justifyContent: "center",
                  }}
                  className="border-b shadow-md flex w-full"
                >
                  {collapsed ? (
                    // When sidebar is collapsed
                    <div className="flex justify-center w-full">
                      <FiChevronsRight
                        onClick={() => collapseSidebar(false)}
                        className="h-6 w-6 cursor-pointer text-gray-600 hover:text-purple-500"
                      />
                    </div>
                  ) : (
                    // When sidebar is expanded
                    <div className="flex items-center justify-between w-full px-2">
                      <Text
                        className="text-2xl md:text-[22px] text-purple-500 sm:text-xl tracking-[0.20px]"
                        size="txtInterSemiBold24"
                        style={{
                          textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
                        }}
                      >
                        PurpleFusion
                      </Text>

                      <FiChevronsLeft
                        onClick={() => collapseSidebar(true)}
                        className="h-6 w-6 cursor-pointer text-gray-600 hover:text-purple-500 ml-2"
                      />
                    </div>
                  )}
                </Menu>

                <div className="h-[90vh] overflow-auto w-30 overflow-y-auto mt-2 pr-1 ">
                  <SubMenu
                    className="group"
                    icon={
                      <FaChartPie className="h-5 mb-2 mt-3 w-full text-blue-500 text-sm group-hover:text-blue-600" />
                    }
                    label={
                      <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                        Reports & Analysis
                      </span>
                    }
                    disabled={collapsed}
                  >
                    {Dashboard?.map((menu, i) => (
                      <MenuItem
                        key={`itemMenu${i}`}
                        {...menu}
                        onClick={() => {
                          if (menu.label === "Supplier PO Report") {
                            sessionStorage.setItem("tab", "Supplier P O");
                          } else if (menu.label === "Sales Order Report") {
                            sessionStorage.setItem(
                              "tab",
                              "TaxInvoiceAgainstSalesOrder"
                            );
                          } else if (menu.label === "Manufacturing Report") {
                            sessionStorage.setItem("tab", "Consumption");
                          } else if (menu.label === "Inventory Reports") {
                            sessionStorage.setItem("tab", "DateWise Report");
                          } else if (menu.label === "Sales Reports") {
                            sessionStorage.setItem("tab", "revenuereport");
                          } else if (menu.label === "Purchase Reports") {
                            sessionStorage.setItem(
                              "tab",
                              "suppliersalesreport"
                            );
                          }
                          navigate(menu.to);
                        }}
                        className={
                          menu.to === location.pathname
                            ? "bg-blue-100 text-blue-500 shadow-md h-5 my-1 rounded-full border-b-2  border-b-blue-400 border-r-2  border-r-blue-400 w-full pl-9 "
                            : "h-5 w-full my-1 pl-9 overflow-hidden "
                        }
                      >
                        <Link
                          className={
                            menu.to === location.pathname
                              ? "text-blue-500"
                              : "w-full hover:bg-gray-200 rounded"
                          }
                          to={menu.to}
                        >
                          <GoDotFill
                            className="inline-block mr-2 text-xs"
                            size={10}
                          />
                          {menu.label}
                        </Link>
                      </MenuItem>
                    ))}
                  </SubMenu>
                  <SubMenu
                    className="group"
                    icon={
                      <TbReportMoney  className="h-5 mb-2 mt-3 w-full text-blue-500 text-sm group-hover:text-blue-600" />
                    }
                    label={
                      <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                        Financial Reports
                      </span>
                    }
                    disabled={collapsed}
                  >
                    {FinancialDashboard?.map((menu, i) => (
                      <MenuItem
                        key={`itemMenu${i}`}
                        {...menu}
                        className={
                          menu.to === location.pathname
                            ? "bg-blue-100 text-blue-500 shadow-md h-5 my-1 rounded-full border-b-2  border-b-blue-400 border-r-2  border-r-blue-400 w-full pl-9 "
                            : "h-5 w-full my-1 pl-9 overflow-hidden "
                        }
                        onClick={() => {
                          if (menu.label === "Costing") {
                            sessionStorage.setItem("tab", "costing");
                          }  
                          navigate(menu.to);
                        }}
                      >
                        <Link
                          className={
                            menu.to === location.pathname
                              ? "text-blue-500"
                              : "w-full hover:bg-gray-200 rounded"
                          }
                          to={menu.to}
                        >
                          <GoDotFill
                            className="inline-block mr-2 text-xs"
                            size={10}
                          />
                          {menu.label}
                        </Link>
                      </MenuItem>
                    ))}
                  </SubMenu>
                  {(erplist.some(
                    (item) => item.erp_module_id === 9 && item.view
                  ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 38 && item.view
                    ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 39 && item.view
                    ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 40 && item.view
                    ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 41 && item.view
                    )) && (
                    <SubMenu
                      className="group"
                      icon={
                        <BiArchive className="h-5 mb-2 mt-3 w-full text-blue-500 text-sm group-hover:text-blue-600" />
                      }
                      disabled={collapsed}
                      label={
                        <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                          Items
                        </span>
                      }
                    >
                      {itemMenu?.map((menu, i) => (
                        <MenuItem
                          key={`itemMenu${i}`}
                          {...menu}
                          onClick={() => navigate(menu.to)}
                          className={
                            menu.to === location.pathname
                              ? "bg-blue-100 text-blue-500 shadow-md h-5 my-1 rounded-full border-b-2  border-b-blue-400 border-r-2  border-r-blue-400 w-full pl-9 "
                              : "h-5 w-full  mt-1 pl-9 overflow-hidden"
                          }
                        >
                          <Link
                            className={
                              menu.to === location.pathname
                                ? " text-blue-500 "
                                : "w-full hover:bg-gray-200 rounded"
                            }
                            to={menu.to}
                          >
                            <GoDotFill
                              className="inline-block mr-2 text-xs"
                              size={10}
                            />
                            {menu.label}
                          </Link>
                        </MenuItem>
                      ))}
                    </SubMenu>
                  )}

                  {(erplist.some(
                    (item) => item.erp_module_id === 10 && item.view
                  ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 11 && item.view
                    ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 12 && item.view
                    ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 17 && item.view
                    ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 32 && item.view
                    ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 13 && item.view
                    )) && (
                    <SubMenu
                      className="group"
                      icon={
                        <MdMapsHomeWork className="h-5 mb-2 mt-3 w-full text-blue-500 text-sm group-hover:text-blue-600" />
                      }
                      label={
                        <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                          Manufacturing
                        </span>
                      }
                      disabled={collapsed}
                    >
                      {ManufactirungMenu?.map((menu, i) => (
                        <MenuItem
                          key={`itemMenu${i}`}
                          {...menu}
                          onClick={() => {
                            if (menu.label === "Job Card") {
                              sessionStorage.setItem("tab", "Job Cards");
                              navigate(menu.to);
                            }
                          }}
                          className={
                            menu.to === location.pathname
                              ? "bg-blue-100 text-blue-500 shadow-md h-5 my-1 rounded-full border-b-2  border-b-blue-400 border-r-2  border-r-blue-400 w-full pl-9 "
                              : "h-5 w-full  mt-1 pl-9 overflow-hidden"
                          }
                        >
                          <Link
                            className={
                              menu.to === location.pathname
                                ? " text-blue-500 "
                                : "w-full hover:bg-gray-200 rounded"
                            }
                            to={menu.to}
                          >
                            <GoDotFill
                              className="inline-block mr-2 text-xs"
                              size={10}
                            />
                            {menu.label}
                          </Link>
                        </MenuItem>
                      ))}
                    </SubMenu>
                  )}

                  {(erplist.some(
                    (item) => item.erp_module_id === 15 && item.view
                  ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 23 && item.view
                    ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 29 && item.view
                    ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 45 && item.view
                    )) && (
                    <SubMenu
                      className="group"
                      icon={
                        <MdOutlineSell className="h-5 mb-2 mt-3 w-full text-blue-500 text-sm group-hover:text-blue-600" />
                      }
                      label={
                        <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                          Selling
                        </span>
                      }
                      disabled={collapsed}
                    >
                      {Selling?.map((menu, i) => (
                        <MenuItem
                          key={`itemMenu${i}`}
                          {...menu}
                          className={
                            menu.to === location.pathname
                              ? "bg-blue-100 text-blue-500 shadow-md h-5 my-1 rounded-full border-b-2  border-b-blue-400 border-r-2  border-r-blue-400 w-full pl-9 "
                              : "h-5 w-full  mt-1 pl-9 overflow-hidden"
                          }
                          onClick={() => {
                            if (menu.label === "Credit Note") {
                              sessionStorage.setItem("tab", "CustCreditNote");
                              navigate(menu.to);
                            }
                            if (menu.label === "Debit Note") {
                              sessionStorage.setItem("tab", "CustDebitNote");
                              navigate(menu.to);
                            }
                          }}
                        >
                          <Link
                            className={
                              menu.to === location.pathname
                                ? " text-blue-500 "
                                : "w-full hover:bg-gray-200 rounded"
                            }
                            to={menu.to}
                          >
                            <GoDotFill
                              className="inline-block mr-2 text-xs"
                              size={10}
                            />
                            {menu.label}
                          </Link>
                        </MenuItem>
                      ))}
                    </SubMenu>
                  )}

                  {(erplist.some(
                    (item) => item.erp_module_id === 28 && item.view
                  ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 46 && item.view
                    )) && (
                    <SubMenu
                      className="group"
                      icon={
                        <IoMdPaper className="h-5 mb-2 mt-3 w-full text-blue-500 text-sm group-hover:text-blue-600" />
                      }
                      label={
                        <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                          Buying
                        </span>
                      }
                      disabled={collapsed}
                    >
                      {Buying?.map((menu, i) => (
                        <MenuItem
                          key={`itemMenu${i}`}
                          {...menu}
                          className={
                            menu.to === location.pathname
                              ? "bg-blue-100 text-blue-500 shadow-md h-5 my-1 rounded-full border-b-2  border-b-blue-400 border-r-2  border-r-blue-400 w-full pl-9 "
                              : "h-5 w-full  mt-1 pl-9 overflow-hidden"
                          }
                          onClick={() => {
                            if (menu.label === "GRN Entry") {
                              sessionStorage.setItem("tab", "CPOEntryList");
                            }
                            if (menu.label === "Gate-Pass Entry") {
                              sessionStorage.setItem("tab", "InwardGatePass");
                            }
                            navigate(menu.to);
                          }}
                        >
                          <Link
                            className={
                              menu.to === location.pathname
                                ? " text-blue-500 "
                                : "w-full hover:bg-gray-200 rounded"
                            }
                            to={menu.to}
                          >
                            <GoDotFill
                              className="inline-block mr-2 text-xs"
                              size={10}
                            />
                            {menu.label}
                          </Link>
                        </MenuItem>
                      ))}
                    </SubMenu>
                  )}
                  {erplist.some(
                    (item) => item.erp_module_id === 51 && item.view
                  ) && (
                    <SubMenu
                      className="group"
                      icon={
                        <div
                          onClick={() => {
                            navigate(`/delivarychallan/list`);
                          }}
                        >
                          <FaFileInvoice className="h-5 mb-2 mt-3 w-full text-blue-500 text-sm group-hover:text-blue-600" />
                        </div>
                      }
                      label={
                        <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                          Delivery Challan
                        </span>
                      }
                      disabled={collapsed}
                    >
                      {DelivaryChallan?.map((menu, i) => (
                        <MenuItem
                          key={`itemMenu${i}`}
                          {...menu}
                          onClick={() => navigate(menu.to)}
                          className={
                            menu.to === location.pathname
                              ? "bg-blue-100 text-blue-500 shadow-md h-5 my-1 rounded-full border-b-2  border-b-blue-400 border-r-2  border-r-blue-400 w-full pl-9 "
                              : "h-5 w-full  mt-1 pl-9 overflow-hidden"
                          }
                        >
                          <Link
                            className={
                              menu.to === location.pathname
                                ? " text-blue-500 "
                                : "w-full hover:bg-gray-200 rounded"
                            }
                            to={menu.to}
                          >
                            <GoDotFill
                              className="inline-block mr-2 text-xs"
                              size={10}
                            />
                            {menu.label}
                          </Link>
                        </MenuItem>
                      ))}
                    </SubMenu>
                  )}
                  {(erplist.some(
                    (item) => item.erp_module_id === 27 && item.view
                  ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 47 && item.view
                    )) && (
                    <SubMenu
                      className="group"
                      icon={
                        <IoMdPaper className="h-5 mb-2 mt-3 w-full text-blue-500 text-sm group-hover:text-blue-600" />
                      }
                      label={
                        <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                          Stock Transactions
                        </span>
                      }
                      disabled={collapsed}
                    >
                      {StockTransactions?.map((menu, i) => (
                        <MenuItem
                          key={`itemMenu${i}`}
                          {...menu}
                          onClick={() => {
                            if (menu.label === "Stock Transaction") {
                              sessionStorage.setItem("Otab", "Purchase");
                            } else if (menu.label === "Current Stock") {
                              sessionStorage.setItem("Ttab", "Current Stock");
                            }
                            navigate(menu.to);
                          }}
                          className={
                            menu.to === location.pathname
                              ? "bg-blue-100 text-blue-500 shadow-md h-5 my-1 rounded-full border-b-2  border-b-blue-400 border-r-2  border-r-blue-400 w-full pl-9 "
                              : "h-5 w-full  mt-1 pl-9 overflow-hidden"
                          }
                        >
                          <Link
                            className={
                              menu.to === location.pathname
                                ? " text-blue-500 "
                                : "w-full hover:bg-gray-200 rounded"
                            }
                            to={menu.to}
                          >
                            <GoDotFill
                              className="inline-block mr-2 text-xs"
                              size={10}
                            />
                            {menu.label}
                          </Link>
                        </MenuItem>
                      ))}
                    </SubMenu>
                  )}

                  {erplist.some(
                    (item) => item.erp_module_id === 46 && item.view
                  ) && (
                    <SubMenu
                      className="group"
                      icon={
                        <MdFactCheck className="h-5 mb-2 mt-3 w-full text-blue-500 text-sm group-hover:text-blue-600" />
                      }
                      label={
                        <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                          Quality
                        </span>
                      }
                      disabled={collapsed}
                    >
                      {Quality?.map((menu, i) => (
                        <MenuItem
                          key={`sideBarMenuItem${i}`}
                          {...menu}
                          onClick={() => navigate(menu.to)}
                          className={
                            menu.to === location.pathname
                              ? "bg-blue-100 text-blue-500 shadow-md h-5 my-1 rounded-full border-b-2  border-b-blue-400 border-r-2  border-r-blue-400 w-full pl-9 "
                              : "h-5 w-full  mt-1 pl-9 overflow-hidden"
                          }
                        >
                          <Link
                            className={
                              menu.to === location.pathname
                                ? " text-blue-500 "
                                : "w-full hover:bg-gray-200 rounded"
                            }
                            to={menu.to}
                          >
                            <GoDotFill
                              className="inline-block mr-2 text-xs"
                              size={10}
                            />
                            {menu.label}
                          </Link>
                        </MenuItem>
                      ))}
                    </SubMenu>
                  )}
                  {erplist.some(
                    (item) => item.erp_module_id === 34 && item.view
                  ) && (
                    <SubMenu
                      className="group"
                      icon={
                        <CgShutterstock className="h-5 mb-2 mt-3 w-full text-blue-500 text-sm group-hover:text-blue-600" />
                      }
                      label={
                        <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                          Production
                        </span>
                      }
                      disabled={collapsed}
                    >
                      {Production?.map((menu, i) => (
                        <MenuItem
                          key={`sideBarMenuItem${i}`}
                          {...menu}
                          onClick={() => navigate(menu.to)}
                          className={
                            menu.to === location.pathname
                              ? "bg-blue-100 text-blue-500 shadow-md h-5 my-1 rounded-full border-b-2  border-b-blue-400 border-r-2  border-r-blue-400 w-full pl-9 "
                              : "h-5 w-full  mt-1 pl-9 overflow-hidden"
                          }
                        >
                          <Link
                            className={
                              menu.to === location.pathname
                                ? " text-blue-500 "
                                : "w-full hover:bg-gray-200 rounded"
                            }
                            to={menu.to}
                          >
                            <GoDotFill
                              className="inline-block mr-2 text-xs"
                              size={10}
                            />
                            {menu.label}
                          </Link>
                        </MenuItem>
                      ))}
                    </SubMenu>
                  )}

                  {(erplist.some(
                    (item) => item.erp_module_id === 2 && item.view
                  ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 3 && item.view
                    ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 5 && item.view
                    ) ||
                    erplist.some(
                      (item) => item.erp_module_id === 7 && item.view
                    )) && (
                    <SubMenu
                      className="group"
                      icon={
                        <FaUsers className="h-5 mb-2 mt-3 w-full text-blue-500 text-sm group-hover:text-blue-600" />
                      }
                      label={
                        <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                          Company Administration
                        </span>
                      }
                      disabled={collapsed}
                    >
                      {sideBarMenu?.map((menu, i) => (
                        <MenuItem
                          key={`sideBarMenuItem${i}`}
                          {...menu}
                          onClick={() => navigate(menu.to)}
                          className={
                            menu.to === location.pathname
                              ? "bg-blue-100 text-blue-500 shadow-md h-5 my-1 rounded-full border-b-2  border-b-blue-400 border-r-2  border-r-blue-400 w-full pl-9 "
                              : "h-5 w-full  mt-1 pl-9 overflow-hidden"
                          }
                        >
                          <Link
                            className={
                              menu.to === location.pathname
                                ? " text-blue-500 "
                                : "w-full hover:bg-gray-200 rounded"
                            }
                            to={menu.to}
                          >
                            <GoDotFill
                              className="inline-block mr-2 text-xs"
                              size={10}
                            />
                            {menu.label}
                          </Link>
                        </MenuItem>
                      ))}
                    </SubMenu>
                  )}

                  {/* {erplist.some(
                    (item) => item.erp_module_id === 53 && item.view
                  ) && (
                    <SubMenu
                      className="group"
                      icon={
                        <FaUsers className="h-5 mb-2 mt-3 w-full text-blue-500 text-sm group-hover:text-blue-600" />
                      }
                      label={
                        <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                          Company Accounts
                        </span>
                      }
                      disabled={collapsed}
                    >
                      {CompanyAccount?.map((menu, i) => (
                        <MenuItem
                          key={`sideBarMenuItem${i}`}
                          {...menu}
                          onClick={() => navigate(menu.to)}
                          className={
                            menu.to === location.pathname
                              ? "bg-blue-100 text-blue-500 shadow-md h-5 my-1 rounded-full border-b-2  border-b-blue-400 border-r-2  border-r-blue-400 w-full pl-9 "
                              : "h-5 w-full  mt-1 pl-9 overflow-hidden"
                          }
                        >
                          <Link
                            className={
                              menu.to === location.pathname
                                ? " text-blue-500 "
                                : "w-full hover:bg-gray-200 rounded"
                            }
                            to={menu.to}
                          >
                            <GoDotFill
                              className="inline-block mr-2 text-xs"
                              size={10}
                            />
                            {menu.label}
                          </Link>
                        </MenuItem>
                      ))}
                    </SubMenu>
                  )} */}

                  <SubMenu
                    className="group"
                    icon={
                      <IoSettingsOutline className="h-5 mb-2 mt-3 w-full text-blue-500 text-sm group-hover:text-blue-600" />
                    }
                    label={
                      <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                        Company Setting
                      </span>
                    }
                    disabled={collapsed}
                  >
                    {CompanySetting?.map((menu, i) => (
                      <MenuItem
                        key={`sideBarMenuItem${i}`}
                        {...menu}
                        onClick={() => {
                          if (menu.label === "Setting") {
                            sessionStorage.setItem("tab", "Bank Accounts");
                            navigate(menu.to);
                          }
                          if (menu.label === "DownTime & RejectedReasons") {
                            sessionStorage.setItem("tab", "downTime");
                            navigate(menu.to);
                          }
                        }}
                        className={
                          menu.to === location.pathname
                            ? "bg-gray-200 text-blue-500 shadow-md h-5 mb-1 mt-1 w-full pl-9 "
                            : "h-5 w-full  mt-1 pl-9 overflow-hidden"
                        }
                      >
                        <Link
                          className={
                            menu.to === location.pathname
                              ? " text-blue-500 "
                              : "w-full hover:bg-gray-200 rounded"
                          }
                          to={menu.to}
                        >
                          <GoDotFill
                            className="inline-block mr-2 text-xs"
                            size={10}
                          />
                          {menu.label}
                        </Link>
                      </MenuItem>
                    ))}
                  </SubMenu>

                  {companyusers?.company_id === 1 && (
                    <SubMenu
                      icon={
                        <FaRegAddressCard className="h-5 mb-2 mt-3  w-full text-blue-500" />
                      }
                      label={
                        <span className="flex items-center py-2 px-0.5 w-full rounded-md group-hover:bg-blue-100 group-hover:text-blue-500">
                          ERP Administration
                        </span>
                      }
                      disabled={collapsed}
                    >
                      {ERPAdministration?.map((menu, i) => (
                        <MenuItem
                          key={`sideBarMenuItem${i}`}
                          {...menu}
                          onClick={() => {
                            if (menu.label === "HSN/SAC Management") {
                              sessionStorage.setItem("tab", "HSN");
                              navigate(menu.to);
                            }
                          }}
                          className={
                            menu.to === location.pathname
                              ? "bg-gray-200 text-blue-500 shadow-md h-5 mb-1 mt-1   w-full pl-9 "
                              : "h-5 w-full  mt-1 pl-9 overflow-hidden"
                          }
                        >
                          <Link
                            className={
                              menu.to === location.pathname
                                ? " text-blue-500 "
                                : "w-full hover:bg-gray-200 rounded"
                            }
                            to={menu.to}
                          >
                            <GoDotFill
                              className="inline-block mr-2 text-xs"
                              size={10}
                            />
                            {menu.label}
                          </Link>
                        </MenuItem>
                      ))}
                    </SubMenu>
                  )}
                </div>
              </Menu>
            </Sidebar>

            <div className="overflow-hidden h-[100%] w-full border-l shadow-xl pl-1 ">
              <nav class="bg-white-A700 shadow-md border-b ">
                <div class="container flex p-1 items-center">
                  <div className="flex flex-row items-center justify-start w-full pl-2 h-8">
                    <Text
                      className="text-base md:text-[22px] text-blue-500 sm:text-sm tracking-[0.20px] w-full font-bold"
                      style={{ textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)" }}
                    >
                      {companyusers?.company_name}
                    </Text>
                  </div>
                  <div class="flex items-center justify-around w-full">
                    <div
                      className={
                        collapsed
                          ? "flex flex-row gap-[22px]  items-center justify-around  md:ml-[0]   w-[90%]"
                          : "flex flex-row gap-[22px]  rounded-[10px] items-center justify-around  md:ml-[0]  w-[90%]"
                      }
                    >
                      <div className="flex flex-row gap-3 items-center justify-end  w-full  ">
                        {/* {collapsed && ( */}
                        <Text
                          className={`text-base md:text-[22px] text-blue-500 sm:text-xl tracking-[0.20px]  backdrop-blur-3xl  whitespace-nowrap`}
                          size="txtInterSemiBold24"
                        >
                          Welcome {companyusers?.name?.split(" ")[0]}
                        </Text>
                        {/* )} */}
                        <FaUserCircle
                          className="h-7 w-7 text-blue-500 cursor-pointer"
                          onClick={() => setshowProfile(!showProfile)}
                        />
                      </div>

                      <div
                        ref={profileRef}
                        className={`${
                          showProfile
                            ? "absolute top-[35px] right-10"
                            : "hidden"
                        } z-50 rounded-xl shadow-lg backdrop-blur-3xl border border-gray-300 dark:border-gray-700 dark:bg-gray-800 transition-all duration-300 ease-in-out transform ${
                          showProfile
                            ? "scale-100 opacity-100"
                            : "scale-95 opacity-0"
                        }`}
                      >
                        <div className="flex justify-end p-2">
                          <IoMdClose
                            className="text-gray-500 hover:text-gray-800 dark:text-gray-300 dark:hover:text-white text-xl cursor-pointer transition-colors duration-200"
                            onClick={() => setshowProfile(!showProfile)}
                          />
                        </div>

                        <div className="px-6 py-4 text-gray-700 dark:text-gray-200">
                          <Text className="text-lg font-semibold mb-2">
                            {companyusers?.name}
                          </Text>
                          <Text className="text-sm mb-2">
                            <span className="font-semibold">Designation:</span>{" "}
                            {companyusers?.companydesignationname}
                          </Text>
                          <Text className="text-sm mb-2">
                            <span className="font-semibold">Username:</span>{" "}
                            {companyusers?.login_username}
                          </Text>
                          <Text className="text-sm mb-2">
                            <span className="font-semibold">Email:</span>{" "}
                            {companyusers?.email}
                          </Text>
                          <Text className="text-sm">
                            <span className="font-semibold">Mobile:</span>{" "}
                            {companyusers?.mobilenumber}
                          </Text>
                        </div>

                        <div className="flex justify-center p-4">
                          <Menu
                            menuItemStyles={{
                              button: {
                                padding: "0.5rem 1rem",
                                gap: "0.5rem",
                                color: "#4A5568",
                                fontWeight: 600,
                                fontSize: "14px",
                                fontFamily: "Inter",
                              },
                            }}
                            className="flex flex-col border rounded-md shadow-sm items-center justify-center w-full max-w-xs hover:bg-blue-200 dark:hover:bg-gray-700 transition-colors duration-200"
                          >
                            <MenuItem
                              icon={
                                <MdLogout className="h-5 w-5 text-gray-600 dark:text-gray-300" />
                              }
                              onClick={() => {
                                sessionStorage.clear();
                                navigate(`/loginempty`);
                              }}
                            >
                              Log Out
                            </MenuItem>
                          </Menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
              <div className="w-full h-[94vh] overflow-y-auto ">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      ) : (
        navigate(`/loginempty`)
      )}
    </>
  );
};

Sidebar1.defaultProps = {};

export default Sidebar1;
